// test2298
(2298 && 0);
